// extracted by mini-css-extract-plugin
export default {"waiting_block":"WaitBlock_waiting_block__PnFEK","waiting_block__spiner":"WaitBlock_waiting_block__spiner__FwtvW","waiting_block__texts":"WaitBlock_waiting_block__texts__dKn80"};